import IpubLoading from './src/main'

/* istanbul ignore next */
IpubLoading.install = function(Vue) {
  Vue.component(IpubLoading.name, IpubLoading)
}

export default IpubLoading
